<template>
  <div id="app">
    <nav-header ref="$navHeader"></nav-header>
    <!-- <side-bar></side-bar> -->
    <main ref="mainThing">
        <router-view></router-view>
    </main>
    <!-- <h1>Under maintenance</h1> -->
  </div>
</template>

<script>
import NavHeader from './components/NavHeader';
import SideBar from './components/SideBar';

export default {
    name: 'app',
    components: {
        NavHeader,
        SideBar,
    },
};
</script>

<style lang="scss">
    @import './assets/scss/main';

    main {
        background-color: $light-grey;
    }

    // h1 {
    //     margin-top: 1.5em;
    //     font-size: 40px;
    //     color: $kpmg-blue;
    //     text-align: center;

    //     @media screen and (min-width: $tablet) {
    //         font-size: 45px;
    //     }

    //     @media screen and (min-width: $tablet) {
    //         font-size: 60px;
    //     }
    // }
</style>



// WEBPACK FOOTER //
// src/App.vue